export function ProviderSignature({ children }: { children: React.ReactNode }) {
  return <p className="tw:font-signature tw:text-xl">{children}</p>;
}
